import { Injectable, OnDestroy } from '@angular/core';
import { GlobalMessageService, HttpErrorHandler, Priority, WindowRef } from '@spartacus/core';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Subject, takeUntil } from 'rxjs';
import { ConfigurationService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceErrorHandler extends HttpErrorHandler implements OnDestroy {
  protected readonly destroy$: Subject<void> = new Subject();
  constructor(
    globalMessageService: GlobalMessageService,
    private router: Router,
    private configService: ConfigurationService,
    private windowRef: WindowRef
  ) {
    super(globalMessageService);
  }

  responseStatus = 503;

  handleError(request: HttpRequest<any>, errorResponse: HttpErrorResponse): void {
    if (errorResponse.url.includes('/recipes')) {
      return;
    }
    this.configService
      .getConfig()
      .pipe(takeUntil(this.destroy$))
      .subscribe((config) => {
        if (!request.url.startsWith(config.myAccount.baseUrl)) {
          if (this.windowRef.isBrowser()) {
            this.windowRef.location.assign('/maintenance.html');
          } else {
            this.router.navigate(['/error/503']);
          }
        }
      });
  }

  getPriority(): Priority {
    return Priority.NORMAL;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
